// core
import { Injectable } from '@angular/core';

// services
import { RaptorApiService } from './raptor-api.service';

@Injectable({
  providedIn: 'root'
})
export class RaptorStripeService extends RaptorApiService {

  save(paymentDetails: any): Promise<any> {
    return this.post('/payment/payment_method', paymentDetails).toPromise();
  }

  fetch(): Promise<any> {
    return this.get('/payment/payment_method').toPromise();
  }
}
